import { useState } from 'react'

export const useAccordion = ({ value, callback }) => {
  const [itemOpen, setItemOpen] = useState(value)

  const handleCallback = item => {
    if (itemOpen === item) {
      setItemOpen('')
    } else {
      setItemOpen(item)
    }
    callback(item)
  }

  return {
    itemOpen,
    handleCallback,
  }
}
